module.exports = __webpack_public_path__ + "img/print.ced049f3.png";